module.exports = __webpack_public_path__ + "media/images/athletes/4316-7f77c49df39c8d91d7486a454f855355.png";